"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColorLayer = void 0;
var _paper = _interopRequireDefault(require("paper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useColorLayer = exports.useColorLayer = function useColorLayer(project, initialColorLayerData) {
  var designerLayer = project.layers.designerLayer;
  var colorLayer;
  if (!designerLayer) {
    console.error('Missing designerLayer!');
    return;
  }
  var init = function init(colorLayerData) {
    var _project$layers$color;
    (_project$layers$color = project.layers.colorLayer) === null || _project$layers$color === void 0 || _project$layers$color.remove();
    var color = colorLayerData === null || colorLayerData === void 0 ? void 0 : colorLayerData.color;
    if (!color) {
      return;
    }
    var path = new _paper["default"].Path.Rectangle(project.layers.designerLayer.view.bounds);
    path.fillColor = color;
    colorLayer = new _paper["default"].Layer({
      name: 'colorLayer',
      children: [path],
      locked: true
    });
    colorLayer.blendMode = 'source-in';
    project.addLayer(colorLayer);
  };
  var toggle = function toggle(on) {
    if (!colorLayer) {
      return;
    }
    var onOrig = colorLayer.visible;
    colorLayer.visible = on;
    project.view.update();
    return function () {
      if (onOrig !== on) {
        colorLayer.visible = onOrig;
        project.view.update();
      }
    };
  };
  var dispose = function dispose() {
    var _colorLayer;
    (_colorLayer = colorLayer) === null || _colorLayer === void 0 || _colorLayer.remove();
    colorLayer = null;
  };
  init(initialColorLayerData);
  return {
    init: init,
    toggle: toggle,
    dispose: dispose
  };
};